// extracted by mini-css-extract-plugin
export default {"heading-primary":"Radio_heading-primary__a4QsI","checkbox-input":"Radio_checkbox-input__8mQ0n","checked":"Radio_checked__ba48D"};